import { Radio, RadioChangeEvent, Space } from "antd";
import { BidRequestStatus } from "interfaces";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { USER_CHECK_ROLE_FILTERS } from "./filterUtils";
import { RadioButton } from "ui";

export const CompanyRoleFilters = observer(() => {
  const { amlCheckList } = useStores();

  const handleStatusClick = (e: RadioChangeEvent) => {
    amlCheckList.onChangeDataFlow({
      filters: { companyRole: [e.target.value] },
      sorters: e.target.value
        ? { ...amlCheckList.sorters, created: "asc" }
        : {
            ...amlCheckList.sorters,
            created: amlCheckList.defaultSorters["created"],
          },
    });
  };

  const relevantStatusTexts = Object.entries(USER_CHECK_ROLE_FILTERS).reduce(
    (acc, [key, value]) => {
      acc[key as BidRequestStatus] = value;
      return acc;
    },
    {} as Record<BidRequestStatus, string>
  );

  const currentFilterStatus = amlCheckList.queryParams?.companyRole?.[0] || undefined;

  return (
    <Space>
      <Radio.Group
        name="type"
        optionType="button"
        buttonStyle="solid"
        className="radio-group"
        onChange={handleStatusClick}
        value={currentFilterStatus}
      >
        <RadioButton value={undefined} colored="grey">
          Все
        </RadioButton>
        {Object.keys(relevantStatusTexts).map((key) => {
          return (
            <RadioButton value={key} colored="grey" key={key}>
              {relevantStatusTexts[key as BidRequestStatus]}
            </RadioButton>
          );
        })}
      </Radio.Group>
    </Space>
  );
});
